// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"51f80b6e","220":"b08eb560","420":"5c5c295e","830":"34496153","981":"18b2a130"}[chunkId] + ".chunk.css";
};